import BISApuestatotalService from "./partners/apuestatotal";
import BISBonanzaService from "./partners/bonanza";

const bisAdapter = {
  apuestatotal: BISApuestatotalService,
  bonanza: BISBonanzaService,
};

class BISService {
  static token = null;

  static authorize = (token) => {
    this.token = token;
  }

  static validate = (config, partnerName, body, options = {}) => {
    const service = bisAdapter[partnerName];
    return service?.validate(config, this.token, body, options);
  };

  static createBet = (config, partnerName, body) => {
    const service = bisAdapter[partnerName];
    return service?.createBet(config, this.token, body);
  };

  static payBet = (config, partnerName, body) => {
    const service = bisAdapter[partnerName];
    return service?.payBet(config, this.token, body);
  };
}

export default BISService;
